import { Modal, MuniSpinner2 } from "../../../components";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import { useActasStore } from "../../../store/actasStore";
import { AnimatePresence, motion } from "framer-motion";
import GenerarActa from "../../../screens/Actas/Acta/Proceso/GenerarActa";
import useMeasure from "react-use-measure";
import { useActaDetalleStore } from "../../../store/actaDetalleStore";


const ModalGenerarActa = ({modals, handlerModal}) => {

    //? ESTADOS GLOBALES
    const { loads } = useGeneralAppStore();
    const { setActaDetalle } = useActasStore();
    const { actaDetalle } = useActaDetalleStore()
    
    const { acta } = actaDetalle;
    const [ref, bounds] = useMeasure();

    return (
        <>
            <Modal
                show={modals.includes('generar_acta')}
                size={"md"}
                onHide={() => handlerModal({ modal: false, modalName: "generar_acta" })}
                title={() => "Generar acta"}
            >
                <div className="position-relative">
                    {
                        loads.includes('generar_acta') &&
                        <div className="position-absolute h-100 w-100 z-3" style={{ backgroundColor: "rgba(255,255,255,0.7)" }}>
                            <MuniSpinner2 />
                        </div>
                    }
                    <AnimatePresence>
                        <motion.div animate={{ height: bounds.height }} className="overflow-hidden">
                            <div ref={ref} /* style={{maxHeight: '150px', overflowY: 'scroll'}} */>
                                <h4 className="text-danger fw-bold text-center mb-3">
                                    La persona {!acta?.domicilio_notificacion_id ? "no" : ""} tiene domicilio electrónico
                                    {acta?.domicilio_notificacion_id && !acta?.fecha_notificacion
                                        ? ". El acta NO cuenta con fecha de notificación"
                                        : ""}
                                    .
                                </h4>

                                {!acta?.domicilio_notificacion_id ||
                                    (acta?.domicilio_notificacion_id && !acta?.fecha_notificacion) ? (
                                    <GenerarActa acta={acta} setActaDetalle={setActaDetalle}
                                    // setActa={setActa} setArchivos={setArchivos} 
                                    />
                                ) : (
                                    ""
                                )}
                            </div>
                        </motion.div>
                    </AnimatePresence>
                </div>



            </Modal>
        </>
    );
}
export default ModalGenerarActa;